import { createEntityAdapter } from '@reduxjs/toolkit'

import { PlanningShift } from '../models/planning/PlanningShift'

export const planningShiftsAdapter = createEntityAdapter({
  selectId: (shift: PlanningShift) => shift.id,
})